import { useReducer, useEffect } from "react";
import urls from "../constants";
import { exists, isEmpty } from "../utils/Validate";
import queryString from "query-string";

const ACTION = {
  API_REQUEST: "api-request",
  FETCH_DATA: "fetch-data",
  ERROR: "error"

}

const initialState = {
  data: [],
  loading: true,
  error: null,
  status: null
}

const groupOfArray = ["project", "company", "Customer", "distributor", "quotation", "inquiry", "quotationsummary", "order"];
function reducer(state, { type, payload }) {
  switch (type) {
    case ACTION.API_REQUEST:
      return { ...state, data: [], loading: true }
    case ACTION.FETCH_DATA:
      return { ...state, data: payload, loading: false }
    case ACTION.POST_DATA:
      return { ...state, status: "sucess", loading: false }
    case ACTION.ERROR:
      return { ...state, data: [], error: payload, loading: false }
    default:
      return state;
  }
}

let isLoggingOut = false;

const resolveManufacturingFacilityCompanyId = (params = {}) => {
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  return (
    params?.companyId ||
    params?.companyID ||
    params?.row?.companyId ||
    userProfile?.userCompanyId ||
    ""
  );
};

const clearAllCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name =
      eqPos > -1
        ? cookie.substr(0, eqPos).trim()
        : cookie.trim();

    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

export const handleAuthError = () => {
  if (isLoggingOut) return;

  isLoggingOut = true;

  window.__STOP_API__ = true;

  localStorage.clear();
  sessionStorage.clear();

  document.cookie.split(";").forEach((cookie) => {

    const eqPos = cookie.indexOf("=");

    const name =
      eqPos > -1
        ? cookie.substr(0, eqPos).trim()
        : cookie.trim();

    document.cookie =
      `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });

  window.dispatchEvent(new Event("authChange"));
};
function FetchData(resource, params) {

  const userId = localStorage.getItem("authidentity")
  const userProfile = JSON.parse(localStorage.getItem("userProfile"))

  const [state, dispatch] = useReducer(reducer, initialState);

  let apiUrl = getApiUrl(resource, params)
  if (params?.skip || !apiUrl) {
    apiUrl = "";
  }
  if (apiUrl && groupOfArray.includes(resource)) {
    const separator = apiUrl.includes("?") ? "&" : "?";

    apiUrl = `${apiUrl}${separator}userId=${userId}&userType=${userProfile?.userType}`;
  }
  let url = `${apiUrl}`;

  useEffect(() => {
    if (
      !url ||
      isLoggingOut ||
      window.__STOP_API__ ||
      !localStorage.getItem("authToken")
    ) {
      return;
    }

    if (url.includes("/undefined") || url.includes("=undefined") || url.includes("/null") || url.includes("=null")) {
      return;
    }

    dispatch({ type: ACTION.API_REQUEST })
    const requestOptions = httpHeaders()
    if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          handleAuthError();
          return Promise.reject("Unauthorized");
        }
        if (response.status === 403) {
          return Promise.reject("Forbidden");
        }
        return response.json()
      })
      .then((data) => {
        if (data?.statusCode === 500)
          dispatch({ type: ACTION.ERROR, payload: "Error" })
        else
          dispatch({ type: ACTION.FETCH_DATA, payload: data })
      })
      .catch((e) => {
        if (e === "Unauthorized") return;
        dispatch({ type: ACTION.ERROR, payload: e.error })
      });

  }, [url])

  return state;
}

export const PaginationFetchData = (resource, params) => {
  const userId = localStorage.getItem("authidentity")
  const userProfile = JSON.parse(localStorage.getItem("userProfile"))

  const [state, dispatch] = useReducer(reducer, initialState);

  let apiUrl = getApiUrl(resource, params)
  if (resource === "quotation") {
    apiUrl = `${apiUrl}&userId=${userId}`;
  }
  else if (groupOfArray.includes(resource)) {
    apiUrl = `${apiUrl}&userId=${userId}&userType=${userProfile?.userType}`;
  }
  let url = `${apiUrl}`;

  useEffect(() => {
    if (
      isLoggingOut ||
      window.__STOP_API__ ||
      !localStorage.getItem("authToken")
    ) {
      return;
    }

    dispatch({ type: ACTION.API_REQUEST })
    const requestOptions = httpHeaders()
    if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

    fetch(url, requestOptions)
      .then((response) => {
        if (response?.statusCode === 401 || response.status === 401) {
          handleAuthError();
          return Promise.reject("Unauthorized");
        }
        if (response?.statusCode === 403 || response.status === 403) {
          return Promise.reject("Forbidden");
        }
        return response.json()
      })
      .then((data) => {
        if (data?.statusCode === 500)
          dispatch({ type: ACTION.ERROR, payload: "Error" })
        else
          dispatch({ type: ACTION.FETCH_DATA, payload: data })
      })
      .catch((e) => {
        if (e?.errors === "Unauthorized") return;
        dispatch({ type: ACTION.ERROR, payload: e.error })
      });

  }, [url])

  return state;
}

export const GetListAsync = async (resource, params) => {
  try {
    const userId = localStorage.getItem("authidentity");
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));

    // Construct API URL
    let apiUrl = getApiUrl(resource, params);
    if (groupOfArray.includes(resource)) {
      apiUrl = `${apiUrl}?userId=${userId}&userType=${userProfile?.userType}`;
    }
    if (
      isLoggingOut ||
      window.__STOP_API__ ||
      !(localStorage.getItem("authToken") || sessionStorage.getItem("authToken"))
    ) {
      return;
    }

    const requestOptions = httpHeaders();
    if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

    const response = await fetch(apiUrl, requestOptions);

    if (response.status === 401) {
      handleAuthError();
      return Promise.reject("Unauthorized");
    }
    if (response.status === 403) {
      return Promise.reject("Forbidden");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return {
      data: data,
      message: "success",
      params: params
    };
  } catch (error) {
    if (error?.message === "Unauthorized") return;
    return {
      data: error.message || "Unknown error",
      message: "Error",
      params: params
    };
  }
};

export const GetList = (resource, params, setListData) => {
  const userId = localStorage.getItem("authidentity")
  const userProfile = JSON.parse(localStorage.getItem("userProfile"))

  let apiUrl = getApiUrl(resource, params)
  if (groupOfArray.includes(resource)) {
    apiUrl = `${apiUrl}?userId=${userId}&userType=${userProfile?.userType}`;
  }
  if (resource === "forecastItemQuoteProduct") {
    apiUrl = `${apiUrl}/${params?.quoteProductItemId}`;
  }
  else if (resource === "forecastProductView") {
    apiUrl = `${urls.FORECAST_PRODUCT_VIEW}/${params?.id}/items`;

    if (params?.View) {
      apiUrl += `?View=${params.View}`;
    }
  }
  let url = `${apiUrl}`;
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    return;
  }

  const requestOptions = httpHeaders();
  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

  fetch(url, requestOptions)
    .then((response) => {

      if (response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response.status === 403) {
        return Promise.reject("Forbidden");
      }
      return response.json()
    })
    .then((data) => {
      setListData({ data: data, message: "success", params: params })
    })
    .catch((e) => {
      if (e === "Unauthorized") return;
      setListData({ data: e?.errors, message: "Error", params: params })
    });

}

export const GetOne = (resource, params, setListData) => {
  let apiUrl = getApiUrl(resource, params);
  let url = `${apiUrl}/${params?.id}`;
  if (resource === "forecastItemQuoteProduct") {
    apiUrl = `${apiUrl}/${params?.quoteProductItemId}`;
  }
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    return;
  }

  const requestOptions = httpHeaders();
  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;
  return fetch(url, requestOptions)
    .then((response) => {
      if (response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response.status === 403) {
        return Promise.reject("Forbidden");
      }
      return response.json()

    })
    .then((data) => {
      setListData({ data: data, message: "success" })
    })
    .catch((e) => {
      if (e?.errors === "Unauthorized") return;
      setListData({ data: e?.errors, message: "Error" })
    });

}

export const RegistrationEntry = async (resource, params, setCreateMsg, successMessage, failureMessage) => {
  const apiUrl = getApiUrl(resource, params);
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    return;
  }

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(params),
  };
  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

  fetch(apiUrl, requestOptions)
    .then(response => {

      if (response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response.status === 403) {
        return Promise.reject("Forbidden");
      }
      return response.json()
    })
    .then(data => {
      if (data?.status === 400 || data?.statusCode === 400) {
        setCreateMsg({
          successData: data,
          message: "Faliure"
        })
      }
      else {
        setCreateMsg({
          successData: data,
          message: successMessage
        })
      }
    })
    .catch((error) => {
      if (error === "Unauthorized") return;
      setCreateMsg({
        successData: { error },
        message: failureMessage
      })
    })
};

const PUBLIC_RESOURCES = ["forgotpassword", "verifyotp", "resetpassword", "changepassword"];

export const CreateEntry = (resource, params, setCreateMsg, successMessage, failureMessage) => {
  let apiUrl = getApiUrl(resource, params);

  let payload = params;

  if (
    resource === "quotationRequest" ||
    resource === "quotationApprovalRequest" ||
    resource === "factoryApprovalRequest" ||
    resource === "factoryApprovalDecision"
  ) {
    const { id, ...rest } = params;
    payload = rest;
  }
  if (resource === "manufacturingFacility") {
    const { companyId, companyID, ...rest } = params || {};
    payload = rest;
  }
  if (resource === "forecastItemQuoteProduct") {
    apiUrl = `${apiUrl}/${params?.quoteProductItemId}`;
  }
  if (resource === "factorycreateorder") {
    const { id, customerOrderId, ...rest } = params;
    payload = rest;
  }

  const isPublic = PUBLIC_RESOURCES.includes(resource);

  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    (!isPublic && !localStorage.getItem("authToken"))
  ) {
    return;
  }

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("authToken")
    },
    body: JSON.stringify(payload)
  };
  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

  return fetch(apiUrl, requestOptions)
    .then(response => {

      if (!isPublic && response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (!isPublic && response.status === 403) {
        return Promise.reject("Forbidden");
      }
      return response.json()
    })
    .then(data => {
      if (data?.status === 400 || data?.statusCode === 400 || data?.statusCode === 404 || data?.statusCode === 500) {
        const apiErrorMessage = data?.errors?.[0]?.message;
        setCreateMsg({
          successData: data,
          message: apiErrorMessage || failureMessage,
          status: data?.statusCode || 400
        })
      }
      else {
        setCreateMsg({
          successData: data,
          message: successMessage,
          status: 200

        })
      }
    })
    .catch((error) => {
      if (error === "Unauthorized") return;
      setCreateMsg({
        successData: { error },
        message: failureMessage,
        status: 500
      })
    })
}

export const UpdatePutEntry = (
  resource,
  params,
  onSuccess,
  setCreateMsg,
  successMessage,
  failureMessage
) => {
  let apiUrl = getApiUrl(resource, params);

  const { id, ...payload } = params;
  if (resource === "forecastItemQuoteProduct") {
    apiUrl = `${apiUrl}/${params?.quoteProductItemId}`;
  }
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    return;
  }

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(payload),
  };
  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

  return fetch(apiUrl, requestOptions)
    .then((response) => {
      if (response?.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response?.status === 403) {
        return Promise.reject("Forbidden");
      }
      if (response?.status === 204) {
        setCreateMsg({
          successData: {},
          message: successMessage,
          status: 204
        });
        return null;
      } else {
        return response.json();
      }
    })
    .then(data => {
      if (!data) return null;
      if (data?.status === 400 || data?.statusCode === 400 || data?.statusCode === 404 || data?.statusCode === 500) {

        const errorMessage =
          data?.errors?.[0]?.message || failureMessage;

        setCreateMsg({
          successData: data,
          message: errorMessage,
          status: data?.statusCode || 400
        });
      } else {
        setCreateMsg({
          successData: data,
          message: successMessage,
          status: 200
        });
        if (onSuccess) onSuccess(data);
      }
    })
    .catch((error) => {
      if (error === "Unauthorized") return;
      setCreateMsg({
        successData: { error },
        message: failureMessage,
        status: 500,
      });
    });
};

export const UpdateEntry = (resource, params, setCreateMsg, successMessage, failureMessage) => {
  let apiUrl = getApiUrl(resource, params);
  let payload = resource === "productmarkmargin"
    ? { margin: params?.margin }
    : resource === "multiplemargin"
      ? { productMargins: params?.productMargins || params?.margins || params }
      : params;
  if (resource === "renamemarkname")
    apiUrl = `${apiUrl}`;
  else if (resource === "rolemultiplier")
    apiUrl = `${apiUrl}/${params?.roleId}`;
  else if (resource === 'approval')
    apiUrl = `${apiUrl}/${params?.formId}`;
  else if (resource === "factorycreateorder") {
    const { id, customerOrderId, ...rest } = params || {};
    payload = rest;
    apiUrl = `${apiUrl}`;
  }
  else if (resource === "manufacturingFacility") {
    const companyId = resolveManufacturingFacilityCompanyId(params);
    const { companyId: companyIdParam, companyID, ...rest } = params || {};
    payload = rest;
    apiUrl = `${urls.MANUFACTURING_FACILITY_BASE_URL}/${companyId}/manufacturing-facilities/${params?.id}`;
  }
  else if (resource === "notificationread" || resource === "notificationreadall" || resource === "notificationarchive")
    apiUrl = `${apiUrl}`;
  else if (resource === "productmarkmargin")
    apiUrl = `${apiUrl}`;
  else if (resource === "multiplemargin")
    apiUrl = params?.id ? `${apiUrl}?id=${encodeURIComponent(params.id)}` : `${apiUrl}`;
  else
    apiUrl = `${apiUrl}/${params?.id}`;
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    return;
  }

  const requestOptions = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('authToken')
    },
    body: JSON.stringify(payload)
  };

  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

  return fetch(apiUrl, requestOptions)
    .then(response => {

      if (response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response.status === 403) {
        return Promise.reject("Forbidden");
      }
      if (response?.status === 204) {
        setCreateMsg({
          successData: {},
          message: successMessage,
          status: 204
        });
      } else {
        return response.json();
      }
    })
    .then(data => {
      if (!data) return null;
      if (data?.status === 400 || data?.statusCode === 400 || data?.statusCode === 404 || data?.statusCode === 500) {
        const apiErrorMessage = data?.errors?.[0]?.message;
        setCreateMsg({
          successData: data,
          message: apiErrorMessage || failureMessage,
          status: data?.statusCode || 400
        });
      } else {
        setCreateMsg({
          successData: data,
          message: successMessage,
          status: 200
        });
      }
    })
    .catch(error => {
      if (error === "Unauthorized") return;
      setCreateMsg({
        successData: {},
        message: failureMessage,
        status: 400
      });
    });
};

export const CompleteQuotationRevision = async (quotationId, draftId) => {
  if (!quotationId || !draftId) {
    throw new Error("Quotation ID and revision draft ID are required.");
  }
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    throw new Error("You must be signed in to complete a quotation revision.");
  }
  if (sessionStorage.getItem("stopApiCalls")) {
    throw new Error("Quotation requests are currently paused.");
  }

  const response = await fetch(
    `${urls.QUOTATION_URL}/${encodeURIComponent(quotationId)}/revision/complete`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
      body: JSON.stringify({ draftId }),
    }
  );

  const responseText = await response.text();
  let responseData = null;
  if (responseText) {
    try {
      responseData = JSON.parse(responseText);
    } catch {
      responseData = { message: responseText };
    }
  }

  if (response.status === 401) {
    handleAuthError();
    throw new Error("Your session has expired. Sign in again to continue.");
  }
  if (response.status === 403) {
    throw new Error(
      responseData?.errors?.[0]?.message ||
      responseData?.message ||
      "You do not have permission to complete this quotation revision."
    );
  }
  if (
    !response.ok ||
    responseData?.status === 400 ||
    responseData?.statusCode === 400 ||
    responseData?.statusCode === 404 ||
    responseData?.statusCode === 500
  ) {
    throw new Error(
      responseData?.errors?.[0]?.message ||
      responseData?.message ||
      "Failed to complete quotation revision."
    );
  }

  return responseData;
};

export const DeleteEntry = (resource, params, setCreateMsg, successMessage, failureMessage) => {

  let apiUrl = getApiUrl(resource, params);
  if (resource == "order") {
    apiUrl = `${apiUrl}/orders/${params?.id}`;
  } else if (resource === "notificationdelete") {
    apiUrl = `${apiUrl}`;
  } else if (resource === "manufacturingFacility") {
    const companyId = resolveManufacturingFacilityCompanyId(params);
    apiUrl = `${urls.MANUFACTURING_FACILITY_BASE_URL}/${companyId}/manufacturing-facilities/${params?.id}`;
  } else if (resource === "forecastItemQuoteProduct") {
    apiUrl = `${apiUrl}/${params?.quoteProductItemId}`;
  } else if (resource === "forecastProductItemDelete") {
    apiUrl = `${apiUrl}/${params?.quoteProductId}/forecasts/${params?.forecastId}`;
  } else {
    apiUrl = `${apiUrl}/${params?.id}`;
  }
  if (
    isLoggingOut ||
    window.__STOP_API__ ||
    !localStorage.getItem("authToken")
  ) {
    return;
  }

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("authToken")
    }
  };
  if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

  fetch(apiUrl, requestOptions)
    .then(response => {
      if (response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response.status === 403) {
        return Promise.reject("Forbidden");
      }
      if (response.ok) {
        if (response?.status === 200 || response?.status === 204) {
          setCreateMsg({
            successData: "Successful",
            message: successMessage,
            status: 200
          })
        } else {
          return response.json();
        }
      } else {
        return response.json();
      }
    })
    .then(data => {
      if (!data) return null;
      if (data?.status === 400 || data?.statusCode === 400 || data?.statusCode === 500 || data?.statusCode === 404) {
        setCreateMsg({
          successData: "Failure",
          message: data,
          status: 400
        })
      }
      else {
        setCreateMsg({
          successData: "Successful",
          message: successMessage,
          status: 200
        })
      }
    })
    .catch((error) => {
      if (error === "Unauthorized") return;
      setCreateMsg({
        successData: "Failure",
        message: error,
        status: 400
      })
    })
};

const getApiUrl = (resource, params) => {
  if (params?.skip) return "";

  let apiUrl = "";
  let query = {};

  if (resource === "company") {
    apiUrl = urls.COMPANY_LIST_URL;
  }
  else if (resource === "manufacturingFacility") {
    const companyId = resolveManufacturingFacilityCompanyId(params);
    apiUrl = `${urls.MANUFACTURING_FACILITY_BASE_URL}/${companyId}/manufacturing-facilities`;
  }
  else if (resource === "country") {
    apiUrl = urls.COUNTRY_LIST_URL;
  }
  else if (resource === "distributorType") {
    apiUrl = urls.DISTRIBUTOR_TYPE_URL;
  }
  else if (resource === "currency") {
    apiUrl = urls.CURRENCY_LIST_URL
  }
  else if (resource === "designation") {
    apiUrl = urls.DESIGNATION_LIST_URL
  }
  else if (resource === "distributorDocuments") {
    apiUrl = urls.DOCUMENT_LIST_URL
  }
  else if (resource === "department") {
    apiUrl = urls.DEPARTMENT_LIST_URL
  }
  else if (resource === "generalcountry") {
    apiUrl = urls.GENERAL_COUNTRY_LIST_URL;
  }
  else if (resource === "generalcurrency") {
    apiUrl = urls.GENERAL_CURRENCY_LIST_URL
    if (params?.companyId) query["companyId"] = params.companyId;
  }
  else if (resource === "generaldocumentTypes") {
    apiUrl = urls.GENERAL_DOCUMENT_LIST_URL
  }
  else if (resource === "generaldesignation") {
    apiUrl = urls.GENERAL_DESIGNATION_LIST_URL
  }
  else if (resource === "generaldepartment") {
    apiUrl = urls.GENERAL_DEPARTMENT_LIST_URL
  }
  else if (resource === "distributor") {
    apiUrl = urls.DISTRIBUTER_LIST_URL
  }
  else if (resource === "customertype") {
    apiUrl = urls.CUSTOMERTYPE_LIST_URL
  }
  else if (resource === "Customer") {
    apiUrl = urls.CUSTOMER_POST_URL
  }
  else if (resource === "menu") {
    apiUrl = urls.MENU_LIST_URL
    if (params?.applicationCode) query["applicationCode"] = params.applicationCode
  }
  else if (resource === "userrole") {
    apiUrl = urls.USER_ROLE_URL
  }
  else if (resource === "project") {
    apiUrl = urls.PROJECT_LIST_URL
  }
  else if (resource === "projectsegment") {
    apiUrl = urls.PROJECT_SEGMENT_URL
  }
  else if (resource === "projectstatus") {
    apiUrl = urls.PROJECT_STATUS_URL
  }
  else if (resource === "userprofile") {
    apiUrl = urls.USER_PROFILE_LIST
  }
  else if (resource === "menupermissions") {
    apiUrl = `${urls.USER_PROFILE_LIST}/me/applications/${params?.applicationCode}/menu-permissions`;
  }
  else if (resource === "changepassword") {
    apiUrl = urls.CHANGE_PASSWORD_URL
  }
  else if (resource === "adminresetpassword") {
    apiUrl = urls.ADMIN_RESET_PASSWORD_URL
  }
  else if (resource === "forgotpassword") {
    apiUrl = urls.FORGOT_PASSWORD_URL
  }
  else if (resource === "resetpassword") {
    apiUrl = urls.RESET_PASSWORD_URL
  }
  else if (resource === "registration") {
    apiUrl = urls.USER_REGISTRATION_URL
  }
  else if (resource === "deliveryterms") {
    apiUrl = urls.DELIVERY_TERMS_URL
  }
  else if (resource === "deliverymodes") {
    apiUrl = urls.DELIVERY_MODES_URL
  }
  else if (resource === "paymentterms") {
    apiUrl = urls.PAYMENT_TERMS_URL
  }
  else if (resource === "productfamily") {
    apiUrl = urls.PRODUCT_FAMILY_URL
  }
  else if (resource === "productgroups") {
    apiUrl = urls.PRODUCT_GROUPS_URL
    apiUrl = `${apiUrl}?familyId=${params.familyId}`;
  }
  else if (resource === "productsubgroups") {
    apiUrl = urls.PRODUCT_SUBGROUPS_URL
    apiUrl = `${apiUrl}?groupId=${params.groupId}`;
  }
  else if (resource === "inquiry") {
    apiUrl = urls.INQUIRY_LIST_URL
  }
  else if (resource === "customerStatus") {
    apiUrl = urls.CUSTOMERTYPE_STATUS_URL
  }
  else if (resource === "quotation") {
    apiUrl = urls.QUOTATION_URL
    if (params?.ProjectId) query["ProjectId"] = params?.ProjectId
    if (params?.SearchTerm) query["SearchTerm"] = params?.SearchTerm
    if (params?.ProjectName) query["ProjectName"] = params?.ProjectName
    if (params?.DistributorName) query["DistributorName"] = params?.DistributorName
    if (params?.CountryName) query["CountryName"] = params?.CountryName
    if (params?.CustomerName) query["CustomerName"] = params?.CustomerName
    if (params?.QuoteFromDate) query["QuoteFromDate"] = params?.QuoteFromDate
    if (params?.QuoteToDate) query["QuoteToDate"] = params?.QuoteToDate
  }
  else if (resource === "quotationActivities") {
    apiUrl = `${urls.QUOTATION_ACTIVITIES_URL}/${encodeURIComponent(params?.quotationId || "")}/activities`;
    query["pageNumber"] = params?.pageNumber ?? 1;
    query["pageSize"] = params?.pageSize ?? 25;
    query["includeDetails"] = params?.includeDetails ?? false;
  }
  else if (resource === "quotationsummary") {
    apiUrl = urls.QUOTATION_SUMMARY_URL
    if (params?.ProjectName) query["ProjectName"] = params?.ProjectName
    if (params?.DistributorName) query["DistributorName"] = params?.DistributorName
    if (params?.CountryName) query["CountryName"] = params?.CountryName
    if (params?.CustomerName) query["CustomerName"] = params?.CustomerName
    if (params?.QuoteFromDate) query["QuoteFromDate"] = params?.QuoteFromDate
    if (params?.QuoteToDate) query["QuoteToDate"] = params?.QuoteToDate
  }
  else if (resource === "quotationproject") {
    apiUrl = urls.QUOTATION_PROJECT_URL
    // apiUrl = `${apiUrl}/${params.id}`;
  }
  else if (resource === "quotationStatus") {
    apiUrl = urls.QUOTATION_URL_STATUS
  }
  else if (resource === "searchproduct") {
    apiUrl = urls.PRODUCT_SEARCH_URL
    apiUrl = `${apiUrl}?product=${params.search}`;
  }
  else if (resource === "productsvariants") {
    apiUrl = urls.PRODUCT_VARIANTS_URL
    apiUrl = `${apiUrl}/${params.id}`;
  }
  else if (resource === "productvariantoptions") {
    apiUrl = `${urls.PRODUCTS_URL}/${params?.id}/variant-options`;
  }
  else if (resource === "productconfig") {
    apiUrl = urls.PRODUCTS_URL
    apiUrl = `${apiUrl}?subGroupId=${params.id}`;
  }
  else if (resource === "productsspecification") {
    apiUrl = urls.PRODUCT_SPECIFICATION_URL
    apiUrl = `${apiUrl}/${params.id}`;
  }
  else if (resource === "actuatorlocation") {
    apiUrl = urls.QUOTATION_ACTUATOR_LOCATIONS_URL

    const actuatorParams = {
      Width: params?.Width,
      Height: params?.Height,
      Model: params?.Model,
      MountingOrientation: params?.MountingOrientation,
      TemperatureRating: params?.TemperatureRating,
      Material: params?.Material,
      VelocityRating: params?.VelocityRating,
      PressureRating: params?.PressureRating,
      Sizing: params?.Sizing,
      TransitionType: params?.TransitionType,
      SleeveLength: params?.SleeveLength,
      MountingAccessories: params?.MountingAccessories,
      ActuatorOperation: params?.ActuatorOperation,
      Actuator: params?.Actuator,
    };

    Object.entries(actuatorParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query[key] = value;
      }
    });
  }
  else if (resource === "actuatoroverride") {
    apiUrl = urls.QUOTATION_ACTUATOR_OVERRIDE_URL;

    const overrideParams = {
      DuctWidth: params?.DuctWidth,
      DuctHeight: params?.DuctHeight,
      OrderQuantity: params?.OrderQuantity,
      VelocityRating: params?.VelocityRating,
      PressureRating: params?.PressureRating,
      TemperatureRating: params?.TemperatureRating,
      ActuatorVoltage: params?.ActuatorVoltage,
      ActuatorOperation: params?.ActuatorOperation,
      ActuatorMake: params?.ActuatorMake,
      MountingOrientation: params?.MountingOrientation,
      Model: params?.Model,
      ModelId: params?.ModelId,
      MaterialOfConstruction: params?.MaterialOfConstruction,
      TransitionType: params?.TransitionType,
      Sizing: params?.Sizing,
    };

    Object.entries(overrideParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query[key] = value;
      }
    });
  }
  else if (resource === "transitiontype") {
    apiUrl = urls.QUOTATION_TRANSITION_TYPES_URL

    const transitionParams = {
      DuctWidth: params?.DuctWidth,
      DuctHeight: params?.DuctHeight,
      Model: params?.Model,
      MountingOrientation: params?.MountingOrientation,
      TemperatureRating: params?.TemperatureRating,
      Material: params?.Material,
      VelocityRating: params?.VelocityRating,
      PressureRating: params?.PressureRating,
      Sizing: params?.Sizing,
    };

    Object.entries(transitionParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query[key] = value;
      }
    });
  }
  else if (resource === "quotationStatusUpdate") {
    apiUrl = urls.QUOTATION_STATUS_UPDATE
  }
  else if (resource === "productmarkmargin") {
    apiUrl = urls.PRODUCT_MARK_URL
    apiUrl = `${apiUrl}/${params.id}/margin`;
  }
  else if (resource === "productmark") {
    apiUrl = urls.PRODUCT_MARK_URL
    if (params?.id > 0) apiUrl = `${apiUrl}/${params?.id}`;
    else apiUrl = `${apiUrl}/${params?.quotationId}`;
  }
  else if (resource === "updateproductmark") {
    apiUrl = urls.PRODUCT_MARK_URL
  }
  else if (resource === "multiplemargin") {
    apiUrl = urls.MULTIPLE_MARGIN_URL
  }
  else if (resource === "productmarkdelete") {
    apiUrl = urls.PRODUCT_MARK_URL
  }
  else if (resource === "renamemarkname") {
    apiUrl = urls.UPDATE_MARKNAME_URL
  }
  else if (resource === "listprice") {
    apiUrl = urls.LIST_PRICE_URL
  }
  else if (resource === "ceilinglistprice") {
    apiUrl = urls.CEILING_LIST_PRICE_URL
  }
  else if (resource === "deflectionlistprice") {
    apiUrl = urls.DEFLECTION_LIST_PRICE_URL
  }
  else if (resource === "exhaustgrillelistprice") {
    apiUrl = urls.EXHAUSTGRILL_LIST_PRICE_URL
  } else if (resource === "transfergrilllistprice") {
    apiUrl = urls.TRANSFERGRILL_LIST_PRICE_URL
  } else if (resource === "eggcrategrillelistprice") {
    apiUrl = urls.EGGCRATEGRILL_LIST_PRICE_URL
  } else if (resource === "perforatedlistprice") {
    apiUrl = urls.PORFORATED_LIST_PRICE_URL
  } else if (resource === "circularlistprice") {
    apiUrl = urls.CIRCULAR_LIST_PRICE_URL
  } else if (resource === "jetlistprice") {
    apiUrl = urls.JET_LIST_PRICE_URL
  } else if (resource === "nozzlelistprice") {
    apiUrl = urls.NOZZLE_LIST_PRICE_URL
  } else if (resource === "punkahnozzlelistprice") {
    apiUrl = urls.PUNKAH_NOZZLE_LIST_PRICE_URL
  } else if (resource === "linearbarlistprice") {
    apiUrl = urls.LINEAR_BAR_LIST_PRICE_URL
  } else if (resource === "mitercornerlistprice") {
    apiUrl = urls.MITER_CORNER_LIST_PRICE_URL
  } else if (resource === "flowbarlistprice") {
    apiUrl = urls.FLOW_BAR_LIST_PRICE_URL
  } else if (resource === "mitercornerFBDlistprice") {
    apiUrl = urls.MITER_CORNER_FBD_PRICE_URL
  } else if (resource === "mitercornerLSDlistprice") {
    apiUrl = urls.MITER_CORNER_LSD_PRICE_URL
  } else if (resource === "curvedlinearslotlistprice") {
    apiUrl = urls.CURVED_SLD_PRICE_URL
  } else if (resource === "curvedflowbarlistprice") {
    apiUrl = urls?.CURVED_FBD_PRICE_URL
  } else if (resource === "curvedLBGlistprice") {
    apiUrl = urls?.CURVED_LB_GRILL_PRICE_URL
  } else if (resource === "discvalves") {
    apiUrl = urls?.DISC_VALVES_PRICE_URL
  } else if (resource === "curtainfiredamperlistprice") {
    apiUrl = urls?.CURTAIN_FIRE_DAMPER_URL
  } else if (resource === "ductaccessfoordamperlistprice") {
    apiUrl = urls?.DUCT_ACCESS_DOOR_DAMPER_URL
  } else if (resource === "roundcontrolvolumelistprice") {
    apiUrl = urls?.ROUND_VOLUME_CONTROL_DAMPER_URL
  } else if (resource === "combinationfiresmokeDamper") {
    apiUrl = urls?.COMBINATION_FIRE_SMOKE_URL
  } else if (resource === "smokeDamper") {
    apiUrl = urls?.COMBINATION_FIRE_SMOKE_URL
  } else if (resource === "freshairlouverslistprice") {
    apiUrl = urls?.FRESH_AIR_LOUVERS_PRICE_URL
  }
  else if (resource === "sandtraplouverslistprice") {
    apiUrl = urls?.SAND_TRAP_LOUVERS_PRICE_URL
  }
  else if (resource === "pressureIndependentVavListPrice") {
    apiUrl = urls?.PRESSURE_INDEPENDENT_VAV_PRICE_URL
  }
  else if (resource === "bypassVavListPrice") {
    apiUrl = urls?.BYPASS_VAV_PRICE_URL
  }
  else if (resource === "forecast") {
    apiUrl = urls.FORECAST_URL
    if (params?.quoteId) apiUrl = `${apiUrl}?quoteId=${params.quoteId}`;
  }
  else if (resource === "forecastItem") {
    apiUrl = urls.FORECASTITEM_URL
    if (params?.quoteId) apiUrl = `${apiUrl}/${params.quoteId}`;
  }
  else if (resource === "forecastProductView") {
    apiUrl = urls.FORECAST_PRODUCT_VIEW
    if (params?.quoteProductId) apiUrl = `${apiUrl}/${params.quoteProductId}/items`;
  }
  else if (resource === "forecastItemQuoteProduct") {
    apiUrl = urls.FORECASTITEM_QUOTE_PRODUCT_URl;
  }
  else if (resource === "forecastProductItem") {
    apiUrl = urls.FORECAST_PRODUCT_VIEW
    if (params?.quoteProductId) apiUrl = `${apiUrl}/${params.quoteProductId}/items`;
  }
  else if (resource === "forecastProductItemDelete") {
    apiUrl = urls.FORECAST_PRODUCT_VIEW
  }
  else if (resource === "quotationcopy") {
    apiUrl = urls.COPY_QUOTATION_URL
  }
  else if (resource === "quoteconvertJIH") {
    apiUrl = urls.CONVERT_JIH_QUOTATION_URL
  }
  else if (resource === "quotationRequest") {
    apiUrl = urls.QUOTATION_REQUEST_URL
    if (params?.id) apiUrl = `${apiUrl}/${params.id}/approval-request`;
  }
  else if (resource === "quotationPendingRequest") {
    apiUrl = urls.QUOTATION_APPROVAL_PENDING_URL
    if (params?.id) apiUrl = `${apiUrl}/${params.id}/approval`;
  }
  else if (resource === "quotationApprovalRequest") {
    apiUrl = urls.QUOTATION_REQUEST_APPROVAL_URL
    if (params?.id) apiUrl = `${apiUrl}/${params.id}/approval-decision`;
  }
  else if (resource === "quotationPending") {
    apiUrl = urls.QUOTATION_PENDING_URL
  }
  else if (resource === "lostReason") {
    apiUrl = urls.LOST_REASON_URL
  } else if (resource === "rolemultiplier") {
    apiUrl = urls.MULTPLIER_URL
  } else if (resource === "order") {
    apiUrl = urls.ORDER_LIST_URL
    if (params?.OrderReference) query["OrderReference"] = params?.OrderReference
    if (params?.QuoteReference) query["QuoteReference"] = params?.QuoteReference
    if (params?.Customer) query["Customer"] = params?.Customer
    if (params?.Project) query["Project"] = params?.Project
    if (params?.Distributor) query["Distributor"] = params?.Distributor
    if (params?.pageSize) query["pageSize"] = params?.pageSize
    if (params?.pageNumber) query["pageNumber"] = params?.pageNumber
  } else if (resource === "quotebalance") {
    apiUrl = urls.QUOTE_BALANCE_URL
    if (params?.id) apiUrl = `${apiUrl}?quoteId=${params.id}`;
  } else if (resource === "pendingquotation") {
    apiUrl = urls?.PENDING_QUOTATION
  } else if (resource === "orderproductmark") {
    apiUrl = urls.ORDER_PRODUCT_MARK_URL
    if (params?.id > 0) apiUrl = `${apiUrl}/${params?.id}`;
    else apiUrl = `${apiUrl}/${params?.orderId}`;
  } else if (resource === "updateorderproductmark") {
    apiUrl = urls.ORDER_PRODUCT_MARK_URL
  } else if (resource === "approval") {
    apiUrl = urls.APPROVAL_UPDATE_URL
  }
  else if (resource === "approvallist") {
    apiUrl = urls.APPROVAL_UPDATE_URL
  }
  else if (resource === "notificationlatest") {
    apiUrl = `${urls.NOTIFICATION_READ_URL}?isArchived=false`;
  }
  else if (resource === "notificationread") {
    apiUrl = `${urls.NOTIFICATION_READ_URL}/${params?.id}/read`;
  }
  else if (resource === "notificationreadall") {
    apiUrl = urls.NOTIFICATION_READ_ALL_URL;
  }
  else if (resource === "notificationunreadcount") {
    apiUrl = urls.NOTIFICATION_UNREAD_COUNT_URL;
  }
  else if (resource === "notificationarchive") {
    apiUrl = `${urls.NOTIFICATION_READ_URL}/${params?.id}/archive`;
  }
  else if (resource === "notificationdelete") {
    apiUrl = `${urls.NOTIFICATION_READ_URL}/${params?.id}`;
  }
  else if (resource === "notificationarchivelist") {
    apiUrl = `${urls.NOTIFICATION_READ_URL}?isArchived=true`;
  }
  else if (resource === "notificationpagedlatest") {
    apiUrl = urls.NOTIFICATION_READ_URL;
    query["isArchived"] = false;
  }
  else if (resource === "notificationpagedarchive") {
    apiUrl = urls.NOTIFICATION_READ_URL;
    query["isArchived"] = true;
  }
  else if (resource === "factoryOrder") {
    apiUrl = urls?.FACTORY_ORDER_LIST_URL;
    if (params?.SearchTerm) query["SearchTerm"] = params?.SearchTerm
    if (params?.CustomerId) query["CustomerId"] = params?.CustomerId
    if (params?.ProjectId) query["ProjectId"] = params?.ProjectId
    if (params?.Status !== "" && params?.Status != null) query["Status"] = params?.Status
    if (params?.ReleasedFromDate) query["ReleasedFromDate"] = params?.ReleasedFromDate
    if (params?.ReleasedToDate) query["ReleasedToDate"] = params?.ReleasedToDate
    if (params?.CreatedFromDate) query["CreatedFromDate"] = params?.CreatedFromDate
    if (params?.CreatedToDate) query["CreatedToDate"] = params?.CreatedToDate
  }
  else if (resource === "factorycreateorder") {
    apiUrl = `${urls.FACTORY_ORDER_CREATE_URL}/${params?.id || params?.customerOrderId}`;
  }
  else if (resource === "factorycustomerpending") {
    apiUrl = urls.FACTORY_CUSTOMER_ORDER_PENDING_URL;
    if (params?.CustomerId) query["CustomerId"] = params?.CustomerId
    if (params?.PageNumber) query["PageNumber"] = params?.PageNumber
    if (params?.PageSize) query["PageSize"] = params?.PageSize
    if (params?.UserId) query["UserId"] = params?.UserId
    if (params?.UserType) query["UserType"] = params?.UserType
  }
  else if (resource === "factoryorderitem") {
    apiUrl = `${urls.FACTORY_ORDER_CREATE_URL}/${params?.customerOrderId}/available-items`;
  }
  else if (resource === "factoryrelease") {
    apiUrl = urls.FACTORY_RELEASE_URL;
  }
  else if (resource === "factoryApprovalRequest") {
    apiUrl = urls.FACTORY_APPROVAL_URL;
    if (params?.id) apiUrl = `${apiUrl}/${params.id}/approval-request`;
  }
  else if (resource === "factoryPendingRequest") {
    apiUrl = urls.FACTORY_APPROVAL_URL;
    if (params?.id) apiUrl = `${apiUrl}/${params.id}/approval`;
  }
  else if (resource === "factoryApprovalDecision") {
    apiUrl = urls.FACTORY_APPROVAL_URL;
    if (params?.id) apiUrl = `${apiUrl}/${params.id}/approval-decision`;
  }
  else if (resource === "factoryApprovalPending") {
    apiUrl = urls.FACTORY_APPROVAL_PENDING_URL;
  }
  if (params?.PageNumber) query["PageNumber"] = params?.PageNumber
  if (params?.PageSize) query["PageSize"] = params?.PageSize
  if (!isEmpty(query)) apiUrl = `${apiUrl}?${queryString.stringify(query)}`;
  return apiUrl;
};



export const UpdateQuotationStatus = (resource, params, setCreateMsg, successMessage, failureMessage) => {
  let apiUrl = getApiUrl(resource, params);
  apiUrl = `${apiUrl}`;
  const requestOptions = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('authToken')
    },
    body: JSON.stringify(params)
  };
  fetch(apiUrl, requestOptions)
    .then(response => {
      if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

      if (response.status === 401) {
        handleAuthError();
        return Promise.reject("Unauthorized");
      }
      if (response.status === 403) {
        return Promise.reject("Forbidden");
      }
      if (response?.status === 204) {
        setCreateMsg({
          successData: {},
          message: successMessage
        });
      } else {
        return response.json();
      }
    })
    .then(data => {
      if (!data) return null;
      if (data?.status === 400 || data?.statusCode === 400) { // assuming error response has "statusCode" property
        setCreateMsg({
          successData: data,
          message: failureMessage
        });
      } else {
        setCreateMsg({
          successData: data,
          message: successMessage
        });
      }
    })
    .catch(error => {
      if (error?.response?.status === 401) {
        handleAuthError();
        return;
      }
      setCreateMsg({
        successData: {},
        message: failureMessage
      });
    });
};

const httpHeaders = (options = {}) => {

  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  else if (options.headers === 'password')
    options.headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" })
  else options.headers = new Headers({ Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  if (exists(token)) {
    options.headers.set('Authorization', 'Bearer ' + token);
  }
  return options;
};

export const AsyncCreateEntry = async (resource, params, successMessage, failureMessage) => {
  try {
    const apiUrl = getApiUrl(resource, params);

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("authToken")}`
      },
      body: JSON.stringify(params)
    };

    const response = await fetch(apiUrl, requestOptions);
    if (window.__STOP_API__ || sessionStorage.getItem("stopApiCalls")) return;

    if (response.status === 401) {
      handleAuthError();
      return Promise.reject("Unauthorized");
    }
    if (response.status === 403) {
      return Promise.reject("Forbidden");
    }
    const data = await response.json();

    if (!response.ok) {
      return {
        successData: data,
        message: failureMessage,
        status: response.status
      };
    }

    return {
      successData: data,
      message: successMessage,
      status: response.status
    }

  } catch (error) {
    if (error?.response?.status === 401) {
      handleAuthError();
      return;
    }
    return {
      successData: { error: error.message },
      message: failureMessage,
      status: 500
    }
  }
};


export default FetchData;
